import { BasePageProps, BasePageState, basePageInitialState } from '../BasePage'

import { store } from '../../redux/store'

import { createReducer, createAction } from '@reduxjs/toolkit'

export interface ShipPageProps extends BasePageProps {}

// --------
type ShipState = {
    tipoPolizza: string | undefined
    lunghezza: number | undefined
    peso: number | undefined
    targa: string | undefined
    nome: string | undefined
    porto: string | undefined
    costruttore: string | undefined
    trasportati: number | undefined
    kw: number | undefined
    cavalli: number | undefined
    matricola: string | undefined
    anno: number | undefined
    alimentazione: string | undefined
    marca: string | undefined
    ormeggio: string | undefined
    utilizzo: string | undefined

    alimentazioni: any
    utilizzi: any
    tipologie: any
    luoghi: any

    tipoPolizzaError: string | undefined
    lunghezzaError: string | undefined
    pesoError: string | undefined
    targaError: string | undefined
    nomeError: string | undefined
    portoError: string | undefined
    costruttoreError: string | undefined
    trasportatiError: string | undefined
    kwError: string | undefined
    cavalliError: string | undefined
    matricolaError: string | undefined
    annoError: string | undefined
    alimentazioneError: string | undefined
    marcaError: string | undefined
    ormeggioError: string | undefined
    utilizzoError: string | undefined
}

export type ShipPageState = ShipState & BasePageState

export const shipPageInitialState : ShipPageState = {
    ...basePageInitialState,
    ...{
        tipoPolizza: undefined,
        lunghezza: undefined,
        peso: undefined,
        targa: undefined,
        nome: undefined,
        porto: undefined,
        costruttore: undefined,
        trasportati: undefined,
        kw: undefined,
        cavalli: undefined,
        matricola: undefined,
        anno: undefined,
        alimentazione: undefined,
        marca: undefined,
        ormeggio: undefined,
        utilizzo: undefined,

        tipoPolizzaError: undefined,
        lunghezzaError: undefined,
        pesoError: undefined,
        targaError: undefined,
        nomeError: undefined,
        portoError: undefined,
        costruttoreError: undefined,
        trasportatiError: undefined,
        kwError: undefined,
        cavalliError: undefined,
        matricolaError: undefined,
        annoError: undefined,
        alimentazioneError: undefined,
        marcaError: undefined,
        ormeggioError: undefined,
        utilizzoError: undefined,

        alimentazioni: undefined,
        utilizzi: undefined,
        tipologie: undefined,
        luoghi: undefined,
    }
}

export const shipUpdate = createAction<ShipPageState>('ship/update')

export const shipReducer = createReducer ( 
    shipPageInitialState,
    (builder) => {
        builder.addCase(shipUpdate, (state, action) => {
            return action.payload as ShipPageState
        })
    }
)

export type ShipRootState = ReturnType<typeof store.getState>
export type ShipDispatch = typeof store.dispatch